"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ExpandOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var ExpandOutlineSVG = function ExpandOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M19.41,1.54l9.83-.1a1.13,1.13,0,0,1,.79.35,1.08,1.08,0,0,1,.34.78l-.1,9.87a1.07,1.07,0,0,1-1.06,1.06h0a1,1,0,0,1-1.05-1.05L28.24,5l-8.81,8.84A1,1,0,1,1,18,12.4l8.83-8.82-7.45.08a1,1,0,0,1-1.05-1.05h0A1.08,1.08,0,0,1,19.41,1.54ZM13.66,29.39h0a1,1,0,0,0-1.05-1.05l-7.45.08L14,19.6a1,1,0,1,0-1.42-1.42L3.76,27l.08-7.47a1,1,0,0,0-1-1.05h0a1.07,1.07,0,0,0-1.06,1.06l-.1,9.87a1.08,1.08,0,0,0,.34.78,1.13,1.13,0,0,0,.79.35l9.83-.1A1.08,1.08,0,0,0,13.66,29.39Z"
  }));
};
exports.ExpandOutlineSVG = ExpandOutlineSVG;
ExpandOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ExpandOutlineSVG);
exports.default = _default;